import { inject, injectable } from 'inversify';
import 'reflect-metadata';

import { HttpResponse, IApiGateway, TYPES } from '@desygner/ui-core-api-gateway';

export interface IWorkflowsService {
  getJobs(params: {
    projectId: number | string;
    alias: string;
    limit?: number;
  }): Promise<HttpResponse>;
  submitJob(params: { jobId: number }): Promise<HttpResponse>;
  createJob(params: {
    assignToId: number;
    outputId: number;
    outputType: string;
    action: string;
  }): Promise<HttpResponse>;
}

@injectable()
export class WorkflowsService implements IWorkflowsService {
  constructor(@inject(TYPES.ApiGateway) private readonly apiGateway: IApiGateway) {}

  private get endpointBase() {
    return `workflow/companies/${this.apiGateway.company}`;
  }

  public async getJobs({
    projectId,
    alias,
    limit = 20,
  }: {
    projectId: number | string;
    alias: string;
    limit?: number;
  }): Promise<HttpResponse> {
    return await this.apiGateway.fetch(
      'GET',
      `${this.endpointBase}/linked-jobs/${alias}/${projectId}?limit=${limit}`
    );
  }

  public async submitJob({ jobId }: { jobId: number }) {
    return await this.apiGateway.fetch('PATCH', `${this.endpointBase}/jobs/${jobId}/submitted`);
  }

  public async createJob({
    assignToId,
    outputId,
    outputType,
    action,
  }: {
    assignToId: number;
    outputId: number;
    outputType: string;
    action: string;
  }): Promise<HttpResponse> {
    const payload = {
      assign_to_id: assignToId,
      outputs: [
        {
          output_id: outputId,
          output_type: outputType,
          output_action: action,
        },
      ],
    };

    return await this.apiGateway.fetch(
      'POST',
      `${this.endpointBase}/jobs/simple`,
      JSON.stringify(payload)
    );
  }
}
